<template>
<!-- 成绩管理 弹窗：特殊处理 -->
    <el-dialog :title="specialTextConfig.title" v-if="dialogVisible" :visible.sync="dialogVisible" width="300px" @close="close" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="form" ref="form">
            <el-form-item>
                <el-radio-group v-model="form.examStatus" style="margin-left:40px">
                    <el-radio :label="2" style="margin-right:52px">{{ cheatLabel }}</el-radio>
                    <el-radio :label="3">{{ invalidLabel }}</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">{{ specialTextConfig.cancel }}</el-button>
            <el-button type="primary" @click="submitForm()">{{ specialTextConfig.ok }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {getDict} from "@/api/dict"

export default {
    props: ['row', 'show'],
    data() {
        return {
            dialogVisible: false,
            form: {
                examineeId: null,
                examStatus: 2,
            },
            cheatLabel: '',
            invalidLabel: ''
        };
    },
    computed: {
        specialTextConfig() {
            return this.$store.state.global.textConfig.backend.examineeScore.table.button.special
        }
    },
    watch: {
        show() {
            this.dialogVisible = this.show;
        },
        row() {
            if (this.row) {
                this.form.examineeId = this.row
            }
        }
    },
    created() {
        getDict('exam_status').then(res => {
            let cheat = res.data.find(item => item.dict_value == 2)
            this.cheatLabel = cheat ? cheat.dict_label : ''

            let invalid = res.data.find(item => item.dict_value == 3)
            this.invalidLabel = invalid ? invalid.dict_label : ''
        })
    },
    methods: {
        close() {
            this.dialogVisible = false
            this.form.examStatus = 2
            this.$emit('close', false)
        },
        submitForm() {
            this.$store.dispatch("putSpecialTreatment", this.form).then(res => {
                if (res.status === 200) {
                    this.$message({
                        type: 'success',
                        message: this.specialTextConfig.success
                    });
                    this.$parent.search(1)
                }

            });
            this.close()
        }
    }
}
</script>

<style scoped>

</style>
